import { Row, Col, Form, Input, Select, SelectOption, FormInstance } from "@ir/ui";
import ContactInfo from "../../../../ContactInfoForm";
import { RaiseDisputeUnfiFormValues } from "../RaiseDisputeInterface";
import { Deduction } from "@/core/entities/deduction";

interface UnfiEmailFormContentProps {
  disputeForm: FormInstance<RaiseDisputeUnfiFormValues>;
  getDisputeTypes: () => SelectOption[];
  getDistributionCenters: () => SelectOption[];
  isDisputeTypesLoading: boolean;
  disputeContactInfoList: { label: string; value: string }[];
  deduction: Deduction;
}

const UnfiEmailFormContent = ({
  disputeForm,
  getDisputeTypes,
  getDistributionCenters,
  isDisputeTypesLoading,
  disputeContactInfoList,
  deduction,
}: UnfiEmailFormContentProps) => {
  return (
    <>
      <Form.Item name="disputeType" rules={[{ required: true, message: "Dispute Type is required." }]} label="Dispute Type">
        <Select maxMenuHeight={150} className="select-field" options={getDisputeTypes()} isLoading={isDisputeTypesLoading} isClearable={false} />
      </Form.Item>

      <Row>
        <Col span={6}>
          <Form.Item name="brandName" rules={[{ required: true, message: "Company Name is required." }]} label="Company Name">
            <Input placeholder="Enter company name" isDisabled />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="vendorNumber" rules={[{ required: true, message: "Remit / Lawson Number is required." }]} label="Remit / Lawson Number">
            <Input placeholder="Enter remit / lawson number" isDisabled />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={4}>
          <Form.Item
            name="invoiceNumber"
            rules={[{ required: true, message: "Deduction Number or Invoice Number is required." }]}
            label="Deduction Number or Invoice Number"
          >
            <Input placeholder="Enter deduction number or invoice number" type="text" isDisabled />
          </Form.Item>
          <Form.Item name="checkNumber" label="Check Number">
            <Input placeholder="Enter check number" type="text" isDisabled />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="totalAmount" label="Deduction Amount" rules={[{ required: true, message: "Deduction Amount is required." }]}>
            <Input placeholder="Enter deduction amount" type="text" isDisabled />
          </Form.Item>
          <Form.Item name="poNumber" label="PO Number">
            <Input placeholder="Enter PO number" type="text" isDisabled />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="disputeAmount" rules={[{ required: true, message: "Disputed Amount is required." }]} label="Disputed Amount">
            <Input placeholder="Enter disputed amount" type="number" />
          </Form.Item>
          <Form.Item name="distributionCenter" label="Warehouse">
            <Select
              maxMenuHeight={150}
              className="select-field"
              options={getDistributionCenters()}
              isLoading={isDisputeTypesLoading}
              isClearable={false}
              isDisabled={deduction?.distributionCenterCode?.length > 0}
            />
          </Form.Item>
        </Col>
      </Row>

      {!isDisputeTypesLoading && disputeContactInfoList.length === 0 && (
        <ContactInfo nameLabel="Requestor's Name" emailLabel="Requestor's Email" />
      )}
      {disputeContactInfoList.length > 0 && (
        <Row>
          <Col span={12}>
            <Form.Item
              name="contactInfo"
              rules={[{ required: true, message: "Requestor's Info is required." }]}
              label="Requestor's Info"
              onMetaChange={() => {
                const currentContactInfo = disputeForm.getFieldValue("contactInfo");

                if (currentContactInfo) {
                  disputeForm.setFieldValue("contactName", currentContactInfo.label);
                  disputeForm.setFieldValue("contactEmail", currentContactInfo.value);
                }
              }}
            >
              <Select
                maxMenuHeight={150}
                className="select-field"
                placeholder="Select"
                options={disputeContactInfoList}
                isClearable={false}
                isLoading={isDisputeTypesLoading}
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  );
};

export default UnfiEmailFormContent;
